import apiClient from '../axios';

const vendorService = {
  async getAllVendors(page = 1, perPage = 20, search = '', status = 'all') {
    try {
      const params = new URLSearchParams({
        page: page,
        per_page: perPage
      });
      
      if (search) {
        params.append('search', search);
      }
      
      if (status && status !== 'all') {
        params.append('status', status);
      }
      
      const response = await apiClient.get(`admin/vendors?${params.toString()}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { 
          success: true, 
          data: response.data.data,
          meta: response.data.meta
        };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch vendors',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch vendors',
        errors: error.response?.data?.errors
      };
    }
  },

  async getVendorById(id) {
    try {
      const response = await apiClient.get(`admin/vendors/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch vendor',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch vendor',
        errors: error.response?.data?.errors
      };
    }
  },

  async updateVendor(id, payload) {
    try {
      const response = await apiClient.put(`admin/vendors/${id}`, payload);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to update vendor',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update vendor',
        errors: error.response?.data?.errors
      };
    }
  },

  async deleteVendor(id) {
    try {
      const response = await apiClient.delete(`admin/vendors/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to delete vendor',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete vendor',
        errors: error.response?.data?.errors
      };
    }
  },

  async addVendor(payload) {
    try {
      let config = {};
      if (payload instanceof FormData) {
        config.headers = { 'Content-Type': 'multipart/form-data' };
      }
      const response = await apiClient.post('vendor/register', payload, config);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to add vendor',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to add vendor',
        errors: error.response?.data?.errors
      };
    }
  },

  async uploadProfileImage(vendorId, file) {
    try {
      const formData = new FormData();
      formData.append('profile_image', file);
      const response = await apiClient.post(`admin/vendors/${vendorId}/profile-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, image_url: response.data.image_url };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to upload profile image',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to upload profile image',
        errors: error.response?.data?.errors
      };
    }
  },

  async fetchVendorProfile(vendorId) {
    try {
      const response = await apiClient.get(`admin/vendors/${vendorId}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch vendor profile',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch vendor profile',
        errors: error.response?.data?.errors
      };
    }
  },

  async getAllCategories() {
    try {
      const response = await apiClient.get('admin/categories');
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch categories',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch categories',
        errors: error.response?.data?.errors
      };
    }
  },
};

export default vendorService; 